import { combineReducers } from "redux"
import { activation } from './userActivationReducer'

const activationReducers = combineReducers({
    activation,
})

export default activationReducers